import { ToolOption } from "../ToolOption/Index";
import "./styles.css";
import { BsHandIndexThumbFill } from "react-icons/bs";
import { IoAdd, IoAnalyticsOutline } from "react-icons/io5";
import { ReactComponent as CheckIcon } from "../../../assets/svg/icons/check.svg";
import { ReactComponent as TrashIcon } from "../../../assets/svg/icons/trash.svg";
import { ReactComponent as UndoIcon } from "../../../assets/svg/icons/undo.svg";
import { ReactComponent as RedoIcon } from "../../../assets/svg/icons/redo.svg";
import { CSSProperties } from "react";

type IToolBar = {
  handleSuccess?: () => void;
  handleDiscardChanges?: () => void;
  handleNewFence?: () => void;
  handleUndo?: () => void;
  handleRedo?: () => void;
  disableUndo?: boolean;
  disableRedo?: boolean;
  disableNewFence?: boolean;
  newFenceActive?: boolean;
  style?: CSSProperties;
  secondaryStyle?: CSSProperties;
  hiddenExploreButton?: boolean;
  hiddenDrawButton?: boolean;
  label?: string
};

export function ToolBar({ handleSuccess, handleDiscardChanges, handleNewFence, handleUndo, handleRedo, disableUndo, disableRedo, disableNewFence, newFenceActive, style, secondaryStyle, ...props }: IToolBar) {

  const discardChanges = () => handleDiscardChanges && handleDiscardChanges();
  const handleClickSuccess = () => handleSuccess && handleSuccess();

  return (
    <>
      {(handleUndo || handleRedo || handleNewFence) && (
        <section className="toolbox__container" style={secondaryStyle}>
          <div>
            {handleUndo && (
              <ToolOption
                theme="normal"
                noSelectable
                defaultMode="none"
                title="Desfazer última ação"
                strokeIcon
                onClick={handleUndo}
                disabled={disableUndo}
              >
                <UndoIcon />
              </ToolOption>
            )}
            {handleRedo && (
              <ToolOption
                theme="normal"
                noSelectable
                defaultMode="none"
                title="Refazer última ação"
                strokeIcon
                onClick={handleRedo}
                disabled={disableRedo}
              >
                <RedoIcon />
              </ToolOption>
            )}
            {handleNewFence && (
              <ToolOption
                theme="success"
                noSelectable
                defaultMode="none"
                title="Nova cerca"
                visibleLabel="Nova cerca"
                active={newFenceActive}
                onClick={handleNewFence}
                disabled={disableNewFence}
              >
                <IoAdd />
              </ToolOption>
            )}
          </div>
        </section>
      )}
      <section className="toolbox__container" style={style}>
        <h3>{props.label !== undefined ? props.label : 'Editar arquivo'}</h3>
        <div>
        {!props.hiddenExploreButton && <>
          <ToolOption theme="normal" defaultMode="explore" title="Explorar">
            <BsHandIndexThumbFill />
          </ToolOption>
        </>}

        {!props.hiddenDrawButton && <>
          <ToolOption theme="normal" defaultMode="draw" title="Desenho livre">
            <IoAnalyticsOutline />
          </ToolOption>
        </>}

        <ToolOption
          theme="normal"
          noSelectable
          defaultMode="none"
          title="Descartar alterações"
          onClick={discardChanges}
        >
          <TrashIcon />
        </ToolOption>
        <ToolOption
          theme="success"
          noSelectable
          defaultMode="none"
          title="Confirmar alterações"
          onClick={handleClickSuccess}
        >
          <CheckIcon />
        </ToolOption>
        </div>
      </section>
    </>
  );
}
